export const removePhoneCodePrefix = (fullPhoneNumber: string, countryPhoneCode: string): string =>
  fullPhoneNumber.replace(new RegExp(`^\\${countryPhoneCode}`), "");
